import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminApi } from '../../services/api';
import { AdminUnallocatedScreen } from './AdminUnallocatedScreen';
import { AdminReportScreen } from './AdminReportScreen';
import { AdminOrdersByUserScreen } from './AdminOrdersByUserScreen';
import { AdminExternallyPaidScreen } from './AdminExternallyPaidScreen';
import { AdminImportUsersScreen } from './AdminImportUsersScreen';
import './admin.css';

type Tab = 'unallocated' | 'report' | 'orders' | 'externallyPaid' | 'importUsers';

export const AdminShell: React.FC = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState<Tab>('unallocated');

  const logout = () => { adminApi.clearToken(); navigate('/admin/login'); };

  return (
    <div className="admin-page">
      <div className="admin-shell-header">
        <strong>Yebo Fresh — Payment Admin</strong>
        <button className="admin-btn dismiss" onClick={logout}>Log out</button>
      </div>
      <div className="admin-tabs">
        <button className={tab === 'unallocated' ? 'active' : ''} onClick={() => setTab('unallocated')}>Unallocated</button>
        <button className={tab === 'report' ? 'active' : ''} onClick={() => setTab('report')}>Shop2Shop Report</button>
        <button className={tab === 'orders' ? 'active' : ''} onClick={() => setTab('orders')}>Orders by User</button>
        <button className={tab === 'externallyPaid' ? 'active' : ''} onClick={() => setTab('externallyPaid')}>Externally Paid</button>
        <button className={tab === 'importUsers' ? 'active' : ''} onClick={() => setTab('importUsers')}>Import Users</button>
      </div>
      <div className="admin-content">
        {tab === 'unallocated' && <AdminUnallocatedScreen />}
        {tab === 'report' && <AdminReportScreen />}
        {tab === 'orders' && <AdminOrdersByUserScreen />}
        {tab === 'externallyPaid' && <AdminExternallyPaidScreen />}
        {tab === 'importUsers' && <AdminImportUsersScreen />}
      </div>
    </div>
  );
};
